import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import VeilederSlettingAvRenterDto from './Models/VeilederSlettingAvRenterDto';
import * as Ids from './Models/Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import { VeilederSlettingAvRenterAppState } from './Store/index';
import InfoboksComponent from './Components/InfoboksComponent';
import InntektOgBarnComponent from './Components/InntektOgBarnComponent';
import ResultatCaComponent from './Components/ResultatCaComponent';
import ResultatCbComponent from './Components/ResultatCbComponent';
import { SlettingAvRenterSatser } from './Utilities/SlettingAvRenterSatserApi';
import SiteImproveHandler, { SiteImproveState, SiteImproveEvents, SiteImproveKategorier } from '../Shared/Scripts/Utilities/SiteImproveEventsHandler';

interface AppOwnProps {}
type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);
export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }
    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext, satser } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;
        
        function registerSiteImproveEvents(): void {
            if(!SiteImproveState.Startet) {
                if(resultat.visInntektOgBarn) {
                    //veileder påstartet
                    SiteImproveState.Startet = true;
                    SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, SiteImproveEvents.VeilederStart, SiteImproveHandler.hentOverskrift());
                }
            }

            if(!SiteImproveState.Fullfort) {
                if(resultat.visResultatCa || resultat.visResultatCb) {
                    //veileder fullført
                    SiteImproveState.Fullfort = true;
                    SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, SiteImproveEvents.VeilederFullfort, SiteImproveHandler.hentOverskrift());
                }
            }
        }

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {

            return (
                <div className="c-veileder">
                    {registerSiteImproveEvents()}
                    <InfoboksComponent
                        onChangeHandler = {(nyttValg: boolean): void => {
                            dispatchUpdateValg({ bInntektOgBarn: nyttValg });
                        }}
                    />
                    {resultat.visInntektOgBarn && (
                        <InntektOgBarnComponent
                            locale = {locale}
                            onChangeHandler = {(inntekt: number, antallbarn: number): void => {
                                dispatchUpdateValg({ cInntekt: inntekt, cAntallBarn: antallbarn });
                            }}
                            sporsmalId = {Ids.BoksB}
                            valuta = {valuta}
                        />
                    )}
                    {resultat.visResultatCa && (
                        <ResultatCaComponent
                            satser = {satser}
                            valg = {valg}
                            valuta = {valuta}
                        />
                    )}
                    {resultat.visResultatCb && (
                        <ResultatCbComponent
                            satser = {satser}
                            valg = {valg}
                            valuta = {valuta}
                        />
                    )}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederSlettingAvRenterDto>;
    resultat: ResultatValg;
    satser: SlettingAvRenterSatser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (nyttValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<VeilederSlettingAvRenterAppState, {}, AnyAction>,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederSlettingAvRenterAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
